import React from 'react';
import PropTypes from 'prop-types';
import TextButton from '@spothero/ui/text-button';

const ParkingRestrictionsMonthly = ({hasIntroRate, onRateDetailsClick}) => {
    const onRateDetailsClicked = () => {
        onRateDetailsClick('intro-rate');
    };

    return (
        <div className="ParkingRestrictions">
            {hasIntroRate && (
                <small className="intro-rate">
                    Intro Rate.&nbsp;
                    <TextButton
                        data-section="intro-rate"
                        onClick={onRateDetailsClicked}
                    >
                        Details
                    </TextButton>
                </small>
            )}
        </div>
    );
};

ParkingRestrictionsMonthly.propTypes = {
    hasIntroRate: PropTypes.bool,
    onRateDetailsClick: PropTypes.func,
};

export default ParkingRestrictionsMonthly;
